const useSuspendDossier = () => {
    const getModalTitle = (identifiers: string[], revertSuspend: boolean = false) => {
        let textAction = 'Mise en pause';

        if (revertSuspend) {
            textAction = 'Reprise';
        }

        return identifiers.length > 1
            ? `${textAction} des dossiers ${identifiers.join(', ')}`
            : `${textAction} du dossier ${identifiers.join(', ')}`;
    };

    const getModalDescription = (
        softAction: boolean,
        plural: boolean,
        revertSuspend: boolean = false,
    ) => {
        let textAction = 'd’annulation';

        if (revertSuspend) {
            textAction = 'de reprise';
        }

        if (softAction) {
            return 'Êtes-vous sûr de vouloir effectuer cette action ?';
        }

        if (plural) {
            return `Au moins l'un de vos dossiers est en cours de traitement par nos formalistes, des coûts peuvent s’appliquer en fonction des actions déjà entreprises par nos équipes. Veuillez renseigner ci-dessous la raison de votre demande ${textAction}.`;
        }

        return `Votre dossier est en cours de traitement par nos formalistes, des coûts peuvent s’appliquer en fonction des actions déjà entreprises par nos équipes. Veuillez renseigner ci-dessous la raison de votre demande ${textAction}.`;
    };

    const getConfirmationMessage = (identifiers: string[], revertSuspend: boolean = false) => {
        let textAction = 'suspension';

        if (revertSuspend) {
            textAction = 'reprise';
        }

        if (identifiers.length > 1) {
            return `Vos demandes de ${textAction} des dossiers ${identifiers} ont bien été transmises à nos équipes. Nous revenons vers vous au plus vite.`;
        }

        if (identifiers.length === 1) {
            return `Votre demande de ${textAction} du dossier ${identifiers} a bien été transmise à nos équipes. Nous revenons vers vous au plus vite.`;
        }

        return `Votre demande de ${textAction} a bien été transmise à nos équipes. Nous revenons vers vous au plus vite.`;
    };

    return { getModalTitle, getModalDescription, getConfirmationMessage };
};

export default useSuspendDossier;
